import { NgModule, Optional, Self } from '@angular/core';
import { Router } from '@angular/router';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { routerReducer, RouterStateSerializer, StoreRouterConnectingModule } from '@ngrx/router-store';
import { MergedRouterStateSerializer } from './router-serializer';
import { RouteEffects } from './effects';

export const routerStateConfig = {
  stateKey: 'router', // state-slice name for routing state
};

@NgModule({
  imports: [
    StoreModule.forFeature(routerStateConfig.stateKey, routerReducer),
    EffectsModule.forFeature([RouteEffects]),
    StoreRouterConnectingModule.forRoot(routerStateConfig),
  ],
  exports: [
    StoreModule,
    StoreRouterConnectingModule
  ],
  providers: [
    {
      provide: RouterStateSerializer,
      useClass: MergedRouterStateSerializer,
    }
  ]
})
export class RouterStoreModule {
  constructor(@Self() @Optional() router: Router) {
    if (router == null) {
      console.error('NgrxRouterStoreModule must be imported in the same same level as RouterModule');
    }
  }
}